export default __webpack_public_path__ + "static/media/quie-step-1.1fd477a0.svg";